// eslint-disable-next-line import/prefer-default-export
export const INTERFACE_TYPES = [
  'Admin',
  'End user',
  'Reports',
  'Orders',
  'Invoices',
  'Other',
];
